// client/src/features/rent/enums.ts — the board's wire enum, as a runtime list · RENT-003.
//
// The generated client (`src/client/types.gen.ts`) gives `RentScheduleStatus` as a
// string-literal UNION, and a union has no runtime value: the status `<select>` cannot iterate
// it and `z.enum()` cannot validate a search param against it. So the five members are spelled
// out once here and HELD to the union — `Record<RentScheduleStatus, true>` is exhaustive in both
// directions, so a member RENT-001 adds and this file lacks, or one this file keeps after the
// contract drops it, fails `tsc` in the PR that regenerated the client.
// `features/tenants/enums.ts` and `features/properties/enums.ts` are the shape this copies.
//
// The five names are also the five `enums.RentScheduleStatus.{VALUE}` keys `StatusBadge` renders
// through §9.6.3's one sanctioned computed key — which is exactly why this list must be held to
// the contract rather than typed out freely: a name that drifts renders its own key path.
//
// 03 §8.6 stores the column as a `smallint` (`0=PENDING … 4=CANCELLED`, §3.4's one deliberate
// smallint enum) and the API serialises the NAME. That storage detail is invisible on this wire
// and must stay invisible; typing against the contract's names is what keeps it so.

import type { RentScheduleStatus } from '@/client';

const RENT_SCHEDULE_STATUS_ORDER: Record<RentScheduleStatus, true> = {
  PENDING: true,
  PARTIALLY_PAID: true,
  PAID: true,
  OVERDUE: true,
  CANCELLED: true,
};

export const RENT_SCHEDULE_STATUSES = Object.keys(
  RENT_SCHEDULE_STATUS_ORDER,
) as readonly RentScheduleStatus[];
